/* @flow */

import React from 'react';
import { Header, Message, Segment, Icon, Grid } from 'semantic-ui-react';

type Props = {
  block: EditorialContactBlock,
};

const View = ({ block }: Props) => {
  if (block.url) {
    return (
      <Segment padded>
        <Grid padded>
          <Grid.Row>
            <Header>
              <Icon name="linkify" />
              {block.url}
            </Header>
          </Grid.Row>
          <Grid.Row>
            {block.content}
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }

  return <Message icon="info" header="Aucun lien spécifié" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/link/View.js